import { MenuItem } from "@/core/models";
import { BasePriceCalculationStrategy, CashModifierPriceStrategy } from ".";

export class CashPriceStrategy extends BasePriceCalculationStrategy {

  constructor() {
    super(new CashModifierPriceStrategy());
  }

  protected extractFactorPrice(menuItem: MenuItem): bigint {
    return BigInt(menuItem?.precioBase ?? 0n);
  }
}